import React from 'react';
import './footer.css'
import logo from '../../assets/logo.png'
import pic25 from '../../assets/pic25.png'
import pic26 from '../../assets/pic26.png'
import pic27 from '../../assets/pic27.png'
import Titlefooter from '../common/titles-footer';
import Navsfooter from '../common/navsfooter';
import { Link } from 'react-router-dom';
import Iconnavfooter from '../common/iconnav-footer';
import pic28 from '../../assets/pic28.png'
import pic29 from '../../assets/pic29.png'
import pic30 from '../../assets/pic30.png'
import Lastnavsfooter from '../common/lastnavfooter';




const Footerr = () => {
    return ( 
        <footer className='footer-big-container'>
            <nav className='main-footer'>
                <nav className='row-footer'>
                    <article className='left-box-footer'>
                        <img src={logo} alt='logoo' className='logo-footer'></img>
                        <p className='para-footer'>We are committed to creating exceptional
                             living spaces that combine quality,
                              design, and comfort. </p>

                        <nav className='container-social-media'>
                            <img src={pic25} alt='instagram'></img>
                             <img src={pic26} alt='x'></img>
                             <img src={pic27} alt='facebook'></img>
                        </nav>
                    </article>

                    <nav className='right-part-footer'>
                        <nav className='nav-container-footer'>
                            <Titlefooter title='Quick Links' />
                            <ul className='list-footer'>
                            <Link to="/" class='linksss'>
                                 <Navsfooter title='Home' />
                            </Link>
                             <Link to="/Propertieslist" class='linksss'>
                                 <Navsfooter title='Properties' />
                            </Link>
                                    <Navsfooter title='FAQs' />
                                    <Navsfooter title='Services' />
                                    <Navsfooter title='Contact Us' />
                            </ul>
                        </nav>
                        <nav className='nav-container-footer'>
                            <Titlefooter title='Contact' />
                            <ul className='list-last-part-footer'>
                                <Iconnavfooter imgg={pic28} title='12 El Nile Street
                                , Zamalek, Cairo, Egypt'/>
                                 <Iconnavfooter imgg={pic29} title='+20 2 2735 1234'/>
                                  <Iconnavfooter imgg={pic30} title='Bickora@gmail.com'/>
                            </ul>
                        </nav>
                    </nav>
                </nav>
            </nav>

            <nav className='footer-white-part'>
                <nav className='main-footer-white-part'>
                    <h4 className='small-text-footer'>@2026,Bickora,AllRightsReservedbyBickora</h4>
                    <ul className='list-white-part-footer'>
                     
                        <Lastnavsfooter  title='Privacy Policy'/>
                           <div className='rectangle-last-part-footer'></div>
                         <Lastnavsfooter  title='Terms & Conditions'/>
                            <div className='rectangle-last-part-footer'></div>
                           <Lastnavsfooter  title='Cookies'/>
                    </ul>
                </nav>
            </nav>
        </footer>
     );
}
 
export default Footerr;